'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { ENTER_KEYCODE } from '../../util/index.js';
export const Checkbox = (_a) => {
    var { ariaDescribedBy, id, name, toggle, value, className, inverted, indeterminate = false, checked = false, disabled, error, readOnly, onChange } = _a, other = __rest(_a, ["ariaDescribedBy", "id", "name", "toggle", "value", "className", "inverted", "indeterminate", "checked", "disabled", "error", "readOnly", "onChange"]);
    const checkboxRef = React.useRef(null);
    function onKeyDown(e) {
        if (onChange && e.code === ENTER_KEYCODE) {
            onChange(checked);
        }
    }
    React.useEffect(() => {
        if (!checkboxRef.current)
            return;
        checkboxRef.current.indeterminate = indeterminate;
    });
    const componentClassName = classnames('sparky-c-checkbox', className, {
        'sparky-c-checkbox--inverted': inverted === true,
        'sparky-c-checkbox--error': error === true,
        'sparky-c-checkbox--toggle': toggle === true,
    });
    return (_jsxs("div", Object.assign({ className: componentClassName }, other, { children: [_jsx("input", { id: id, ref: checkboxRef, type: "checkbox", name: name, value: value, checked: checked, className: "sparky-c-checkbox__input", disabled: disabled, readOnly: readOnly, onChange: onChange ? (e) => onChange(e.target.checked) : undefined, "aria-describedby": ariaDescribedBy, onKeyDown: (e) => onKeyDown(e) }), _jsx("span", { className: "sparky-c-checkbox__custom-check" })] })));
};
//# sourceMappingURL=Checkbox.js.map